export const OPTION_ITEM_HEIGHT = 32
